/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShowOneLayerIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Show One Layer',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33.113 17.905 25.68 14.12l7.433-3.769c.241-.123.241-.323 0-.446l-14.688-7.48a.98.98 0 0 0-.85 0L2.887 9.9c-.241.123-.241.323 0 .446l7.407 3.782-7.407 3.777c-.241.123-.241.323 0 .446l7.4 3.767-7.4 3.787c-.241.123-.241.323 0 .446l14.688 7.479a.971.971 0 0 0 .85 0l14.688-7.479c.241-.123.241-.323 0-.446l-7.43-3.771 7.43-3.783c.241-.123.241-.323 0-.446ZM6.857 10.128 18 4.453l11.144 5.675L23.477 13l-5.052-2.572a.936.936 0 0 0-.85 0L12.5 13.011Zm22.287 16L18 31.8 6.857 26.128l5.632-2.887 5.086 2.589a.936.936 0 0 0 .85 0l5.054-2.574Z"
    />
  </svg>`;
};
